export const FileTagTypes = {
  GENERAL: "GENERAL",
  BRAND: "BRAND",
  EQUIPMENT: "EQUIPMENT",
  SOFTWARE: "SOFTWARE",
  GENRE: "GENRE",
  LEVEL: "LEVEL",
  LESSON_TYPE: "LESSON_TYPE",
}